import React from 'react';

interface ResistanceIconProps {
  className?: string;
  title?: string;
}

const ResistanceIcon: React.FC<ResistanceIconProps> = ({ className = "w-4 h-4", title }) => {
  return (
    <>
      {/* Light mode - Light resistance icon */}
      <img
        src="/images/resistance-light-icon.png"
        alt="Resistance"
        className={`${className} dark:hidden`}
        title={title}
      />
      {/* Dark mode - Original resistance icon */}
      <img
        src="/images/resistance-icon.png"
        alt="Resistance"
        className={`${className} hidden dark:block`}
        title={title}
      />
    </>
  );
};

export default ResistanceIcon;

